import { useMemo } from "react";
import cn from "classnames";
import { SeaSearchCardModel } from "entities/SeaSearchCard";
import { Nullable } from "shared/lib/typeCheck.lib";
import { useTranslation } from "shared/localization/localization";
import { Vessel } from "./Vessel";
import styles from "./VesselList.module.scss";
type VesselsProps = {
  className?: string;
  data: Nullable<SeaSearchCardModel>;
};

export const VesselList: RFC<VesselsProps> = ({ data, className }) => {
  const { t } = useTranslation();
  const vessels = useMemo(() => data?.vessels ?? [], [data?.rawData]);
  const hasVessels = vessels.length > 0;

  return (
    <div className={cn(styles.vesselList, !hasVessels && styles.notAvailable, className)}>
      {hasVessels ? (
        vessels.map((vessel, index) => <Vessel key={`${vessel.voyage}_${index}`} vessel={vessel} />)
      ) : (
        <>
          <div className={styles.notAvailableBold}>{t("Vessels are not available at the moment.")}</div>
          <div className={styles.notAvailableNormal}>{t("Please, try again later")}.</div>
        </>
      )}
    </div>
  );
};
